'use strict'
import {bootstrap} from '../bootstrap/bootstrap'

export function attachFilterEvents(filterDropdowns) {
  filterDropdowns.forEach(filter => {
    bootstrap(filter, filter => {
      filter.addEventListener('change', () => {
        const dropdownType = filter.getAttribute('data-name')
        const dropdownSelector = `.dropdown__ui[data-name="${dropdownType}"] span`
        const dropdown = document.querySelector(dropdownSelector)
        dropdown.innerText = filter.options[filter.options.selectedIndex].value
      })
      filter.addEventListener('blur', () => {
        const dropdownType = filter.getAttribute('data-name')
        const dropdownSelector = `.dropdown__ui[data-name="${dropdownType}"] span`
        const dropdown = document.querySelector(dropdownSelector)
        dropdown.innerText = filter.options[filter.options.selectedIndex].value
      })
    })
  })
}
